import CallerIdChecker from '@Containers/CallerIdChecker/CallerIdChecker.container';

const CallerIdCheckerPage: React.FunctionComponent = (): JSX.Element => (
  <CallerIdChecker />
);

export default CallerIdCheckerPage;
